import { createContext } from 'react'

export const ModalSheetContext = createContext(null)
